
import React from "react";  
import { useLocation } from "react-router-dom";  
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";  
import ButtonsSection from '../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection';  
import NoteTable from '../../common_nextgen/common_components/NoteScreenComponents/NoteTable';  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import usePriceScheduleNotes from "./hooks/usePriceScheduleNotes";  
  
const PriceScheduleNote = () => {  
    const location = useLocation();  
    const { selectedPriceSchedules, currentMode, currentIndex: initialIndex = 0 } = location.state || {};  
    const navigateToPage = useCustomNavigate();  
  
    const {  
        notes,  
        newNotes,  
        mode,  
        first,  
        rows,  
        totalRecords,  
        currentIndex,  
        setMode,  
        setFirst,  
        setRows,  
        setCurrentIndex,  
        handleSaveNotes,  
        handleChangeNewNote,  
        onPageChange,  
        exportAsCSV  
    } = usePriceScheduleNotes(selectedPriceSchedules, initialIndex, currentMode);  
  
    const screen_title = "Price Schedule Note";  
    const screen_code = "RCPSN001";  
  
    const columns = mode === 'view'  
        ? [  
            { key: 'psnNote', header: 'Note' },  
            { key: 'chgDate', header: 'Added' },  
            { key: 'chgUserName', header: 'User' }  
        ]  
        : [  
            { key: 'psnNote', header: 'Note' }  
        ];  
  
    const handleBack = () => {  
        if (currentMode === 'edit') {  
            navigateToPage("/edit-price-schedule", { selectedPriceSchedules, currentIndex });  
        } else if (currentMode === 'disp') {  
            navigateToPage("/display-price-schedule", { selectedPriceSchedules, currentIndex });  
        } else {  
            if (currentIndex < selectedPriceSchedules.length - 1) {  
                setCurrentIndex(currentIndex + 1);  
            } else {  
                navigateToPage("/price-schedule", {  
                    priceSchedule: selectedPriceSchedules[selectedPriceSchedules.length - 1],  
                });  
            }  
        }  
    };  
  
    const handleBackAndSetMode = () => {  
        handleBack();  
        setMode("view");  
    };  
  
    function handleModeSwitch() {  
        if (mode === "add") {  
            setMode("view");  
        } else if (mode === "view") {  
            setMode("add");  
        }  
    }  
  
    const leftButtons = [  
        { button_label: 'Back', button_handeler: handleBackAndSetMode, button_key: 'F12' },  
        ...(mode === 'add' ? [{ button_label: 'View', button_handeler: handleModeSwitch, button_key: 'F9' }] : []),  
    ];  
  
    const rightButtons = [  
        ...(mode === 'view' ? [{ button_label: 'Add', button_handeler: handleModeSwitch, button_key: 'F9' }] : []),  
        { button_label: 'Export as CSV', button_handeler: exportAsCSV }  
    ];  
  
    const getName = (selectedPriceSchedules, currentIndex) => (  
        <>  
            <strong>Price Schedule </strong>  
            {selectedPriceSchedules[currentIndex]}  
        </>  
    );  
  
    return (  
        <div className="container">  
            <ButtonsSection ctaButtons={leftButtons} align="left" />  
            <div className="left-aligned-section">  
                <div className="header-section">  
                    <h1>  
                        {screen_title} - <span className="heading-cod">{screen_code}</span>  
                    </h1>  
                </div>  
                <p className="head-name">{getName(selectedPriceSchedules, currentIndex)}</p>  
            </div>  
            <div className="button-sections">  
                <ButtonsSection ctaButtons={rightButtons} align="right" />  
            </div>  
            <NoteTable  
                data={notes}  
                columns={columns}  
                mode={mode}  
                newNotes={newNotes}  
                handleChangeNewNote={handleChangeNewNote}  
                handleSaveNotes={handleSaveNotes}  
            />  
            <NextGenPaginator  
                first={first}  
                rows={rows}  
                totalRecords={totalRecords}  
                currentPage={first / rows}  
                rowsPerPageOptions={[10, 25, 50]}  
                onPageChange={onPageChange}  
            />  
        </div>  
    );  
};  
  
export default PriceScheduleNote;  

